import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const AttentionInvestors = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Attention Investors"
        description="Important notice and compliance guidelines for investors regarding trading and depository services. Stay informed about margin requirements and account security."
      />

      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Attention Investors</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <p>
                <b>a. Trading Compliance</b>
              </p>
              <ul className="listitem">
                <li>
                  Stock Brokers can accept securities as margin from clients
                  only by way of pledge in the depository system w.e.f.
                  September 01, 2020.
                </li>
                <li>
                  Update your email ID and mobile number with your stock broker
                  / depository participant and receive OTP directly from the
                  depository on your email ID and/or mobile number to create a
                  pledge.
                </li>
                <li>
                  Check your securities / MF / bonds in the consolidated account
                  statement issued by NSDL/CDSL every month. Issued in the
                  interest of investors.
                </li>
                <li>
                  All clients are requested to record their email ID for
                  electronic dispatch of contracts and statements. In case of an
                  electronic contract note, the link/login for the same is
                  available on the website for download.
                </li>
                <li>
                  Pay 20% upfront margin of the transaction value to trade in
                  the cash market segment. Investors may please refer to the
                  Exchange’s Frequently Asked Questions (FAQs) issued vide
                  circular reference NSE/INSP/45191 dated July 31, 2020 and
                  NSE/INSP/45534 dated August 31, 2020 and other guidelines
                  issued from time to time in this regard.
                </li>
                <li>
                  No need to issue cheques by investors while subscribing to an
                  IPO. Just write the bank account number and sign in the
                  application form to authorize your bank to make payment in
                  case of allotment. No worries for refund as the money remains
                  in the investor's account.
                </li>
                <li>
                  Submit application letter along with a photocopy of PAN and
                  address proof requesting activation of a dormant account.
                </li>
                <li>
                  All clients are requested to provide the NEFT details of their
                  bank account for receiving direct credit to their account
                  online. Please submit a cancelled cheque to your operating
                  branch.
                </li>
              </ul>

              <p>
                <b>b. DP Compliance</b>
              </p>
              <ul className="listitem">
                <li>
                  Prevent Unauthorized Transactions in your demat account &rarr;
                  Update your Mobile Number with your Depository Participant.
                  Receive alerts on your Registered Mobile for all debit and
                  other important transactions in your demat account directly
                  from NSDL / CDSL on the same day. Issued in the interest of
                  investors.
                </li>
                <li>
                  KYC is a one-time exercise while dealing in securities markets
                  - once KYC is done through a SEBI registered intermediary
                  (broker, DP, Mutual Fund etc.), you need not undergo the same
                  process again when you approach another intermediary.
                </li>
                <li>
                  No need to issue cheques by investors while subscribing to an
                  IPO. Just write the bank account number and sign in the
                  application form to authorize your bank to make payment in
                  case of allotment. No worries for refund as the money remains
                  in the investor's account.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a
                href="#download"
                className="lm-btn"
                onClick={(e) => e.preventDefault()}
              >
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="/images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default AttentionInvestors;
